import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { TransitionLink } from '@/components/generals/transition-link'
import { siteConfig, QUOTE_PATH } from '@/constants/site'

export const EMERGENCY_BAR_HEIGHT = 36

export const EmergencyBar: FC = (): ReactNode => {
    return (
        <div className='h-9 bg-ink-deep text-cream'>
            <Container className='flex h-full items-center justify-end gap-4 text-[12.5px] sm:text-[13px]'>
                <div className='flex shrink-0 items-center gap-5'>
                    <a
                        href={siteConfig.phoneHref}
                        className='font-mono text-[12px] tracking-wide text-cream transition-colors hover:text-ember-soft'
                    >
                        {siteConfig.phone}
                    </a>

                    <TransitionLink
                        href={`${QUOTE_PATH}?service=emergency-repair&entry=text_back`}
                        className='hidden text-cream/60 underline-offset-4 transition-colors hover:text-cream hover:underline md:inline'
                    >
                        Prefer a text back?
                    </TransitionLink>
                </div>
            </Container>
        </div>
    )
}
